<template>
  <el-row style="padding-bottom: 20px">
    <el-col :span="24">

      <div  class="my-swiper-box" >

        <div class="my-swiper-box-bg" :style="{
              '--bgImage': 'url(' + imgserver + VirtualImage + ')',
            }"  ></div>

        <swiper  v-if="bannerList.length > 0" :options="swiperOption" ref="mySwiper" class="custom-carousel"  >
          <swiper-slide v-for="(item, index) in bannerList"
                        :key="index" :index="index"     >
            <div
                 class="banner-block background-image cur-pointer"
            >
              <div class="background-image-bgbox">
                <el-image class="background-image-bg" :src="imgserver + item.url" fit="fill"></el-image>
              </div>

              <div class="swiper-info-box">
                <div class="carousel_title">
                  <span>{{ item.title }}</span>
                </div>
                <div class="carousel_description">
              <span class="carousel_remark" >
                {{ item.remark }}
              </span>
                </div>
<!--                <div class="carousel_details">-->
<!--                  <el-button-->
<!--                      class="carousel_button"-->
<!--                      @click="toBannerDetail(item)"-->
<!--                      v-if="item.jumpPage"-->
<!--                  >了解详情<el-icon class="el-icon-right"></el-icon-->
<!--                  ></el-button>-->
<!--                </div>-->
              </div>

            </div>

          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-next" @click='swiperNext("mySwiper")' slot="button-prev">
            <i class="el-icon-arrow-right" style="color: #fff;"></i>
          </div>
          <div class="swiper-button-prev" @click='swiperPrev("mySwiper")' slot="button-next">
            <i class="el-icon-arrow-left" style="color: #fff;" ></i>
          </div>
        </swiper>

      </div>


    </el-col>
    <!-- 在线报名 -->
    <el-col :span="24" v-if="!pcShowBool">
      <div class="online-sign" @click="onlineSign">
        <img
            src="../assets/img/onlineMobileSign.jpg"
            style="width: 100%; height: 100%"
            alt=""
        />
      </div>
    </el-col>
    <!-- 学校要闻 -->
    <el-col :span="24" v-if="isShowStudent">
      <!-- 标题部分 -->
      <div class="contain-block">
        <div class="college-news" align="midden" justify="start">
          <div class="college-news-title cur-pointer" @click="toNewDetail(1)">
            <span>学校要闻</span>
          </div>
          <div class="college-news-more cur-pointer" @click="toNewDetail(1)">
            <span>更多 ></span>
          </div>
        </div>
        <!-- 实体黑线 -->
        <div>
          <div class="blue-line"></div>
        </div>

        <div class="college-news-content">
          <!-- 学校要闻轮播图 -->
          <div class="college-news-carouse">
            <swiper v-if="homeNewsBannerList.length > 0" :options="swiperCollegeOption" ref="myCollegeSwiper"   >
              <swiper-slide  v-for="(item, index) in homeNewsBannerList" :key="'college' + index"  :index="'college' + index" :height="homeNewsHeight + 'rem'" >
                <div  class="cur-pointer college-news-carouse-item">
                  <div class="college-news-carousel-img">

                    <el-image   style="height: 100%; width: 100%"
                                :src="imgserver + item.url" fit="cover" ></el-image>

                  </div>
                  <div class="college-news-carousel-title ellipsis">
                      <span>
                        {{ item.title }}
                      </span>
                  </div>
                </div>
              </swiper-slide>
            </swiper>


          </div>
          <div class="college-new-content-block">
            <div
                v-for="(item, index) in homeNewsList"
                :key="index"
                class="college-new-content-block-list"
                @click="toNewDetail(2, item)"
            >
              <div
                  class="college-news-content-img"
                  v-if="pcShowBool && (index == 0 || index == 1)"
              >
                <img
                    v-if="item.picUrl"
                    style="width: 100%; height: 100%"
                    :src="imgserver + item.picUrl"
                />

                <img
                    v-else
                    style="width: 100%; height: 100%;object-fit: contain"
                    :src="require('../assets/img/defalutIcon.jpeg')"
                />

              </div>
              <div class="college-news-content-article cur-pointer">
                <div class="college-news-content-title">
                  <div>
                    {{ item.title }}
                  </div>
                </div>
                <div>
                  <div class="gray-line"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :span="24" v-if="isShowIntroduce && homeSubjectList.length > 0">
      <div class="contain-block">
        <div class="college-news" align="midden" justify="start">
          <div
              class="college-news-title cur-pointer"
              @click="toSubjectDetail(1)"
          >
            <span>专业部系介绍</span>
          </div>
          <div
              class="college-news-more cur-pointer"
              @click="toSubjectDetail(1)"
          >
            <span>更多 ></span>
          </div>
        </div>
        <!-- 实体黑线 -->
        <div>
          <div class="blue-line"></div>
        </div>

        <div class="introduce-imgs-content">
          <div
              v-for="(item, index) of homeSubjectList"
              :key="index"
              class="introduce-imgs-item cur-pointer"
              @click="toSubjectDetail(2, item, index)"
          >
            <div style="width: 100%; height: 100%">
              <img
                  style="width: 100%; height: 100%"
                  :src="imgserver + item.picUrl"
              />
            </div>
          </div>
        </div>
      </div>
    </el-col>

    <el-col class="info-image-Honor" :span="24" v-if="isShowStudent">
      <div class="info-block" v-if="isShowInfoPublic">
        <!-- 标题 -->
        <div class="info-title-block">
          <div class="img-title">
            <img
                src="../assets/img/publicNotic.png"
                class="info-title-img"
                alt=""
            />
            <div class="info-title cur-pointer" @click="toPublicInfo(1)">
              <span>信息公开</span>
            </div>
          </div>
          <div class="info-title-more cur-pointer" @click="toPublicInfo(1)">
            <span>更多 ></span>
          </div>
        </div>
        <!-- 虚线 -->
        <div class="blue-line"></div>
        <!-- 内容主题 -->
        <div class="info-content">
          <template   v-for="(item, index) in homeNoticeList" >
            <div
                v-if="index < 8"
                :key="index"
                class="info-content-item"
                @click="toPublicInfo(2, item, index)"
            >
              <div class="dot-title">
                <div class="info-content-dot"></div>
                <div class="info-content-title ellipsis cur-pointer">
                  <span>{{ item.title }}</span>
                </div>
              </div>
              <div class="info-content-time cur-pointer">
                <span> {{ item.opTime.slice(5, 10) }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="info-block" v-if="isShowInfoPublic && homeImagesList.length > 0">
        <!-- 标题 -->
        <div class="info-title-block">
          <div class="img-title">
            <img src="../assets/img/movie.png" class="info-title-img" alt="" />
            <div class="info-title cur-pointer" @click="toImageCenter(1)">
              <span>影像中心</span>
            </div>
          </div>
          <div class="info-title-more cur-pointer" @click="toImageCenter(1)">
            <span>更多 ></span>
          </div>
        </div>
        <!-- 虚线 -->
        <div class="blue-line"></div>
        <!-- 内容主题 -->

        <div class="honor-content">
<!--          <el-carousel  :height="honorSwiperHeight + 'px'"  class="honor-carousel-block" indicator-position="none"  >-->
<!--            <el-carousel-item-->
<!--                v-for="(item, index) in homeImagesList"-->
<!--                :key="index"-->
<!--                class="honor-carousel-item"-->
<!--            >-->
<!--              <div-->
<!--                  class="honor-item cur-pointer"-->
<!--                  @click="toImageCenter(2, item, index)"-->
<!--              >-->
<!--                <div :span="24" class="honor-item-img">-->
<!--                  <img ref="honorImgRef" @load="honorImgLoad" :src="imgserver + item.picUrl" alt="" />-->
<!--                  <span>{{item.title}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->

          <swiper v-if="homeImagesList.length > 0" :options="swiperHonorOption" ref="myHonorSwiper" class="honor-swiper" :style="{height: honorSwiperHeight + 'px'}"  >
            <swiper-slide   v-for="(item, index) in homeImagesList" :key="'honor-' + index"  :index="'college' + index"  >

              <div  class="honor-carousel-block">
                <div class="honor-carousel-item" >
                  <div
                      class="honor-item cur-pointer"
                      @click="toImageCenter(2, item, index)"
                  >
                    <div :span="24" class="honor-item-img">
                      <img ref="honorImgRef" @load="honorImgLoad" style="width: 100%;height: 100%;object-fit: fill;" :src="imgserver + item.picUrl" alt="" />
                      <span>{{item.title}}</span>
                    </div>
                  </div>
                </div>
              </div>

            </swiper-slide>

            <div class="swiper-button-next" @click='swiperNext("myHonorSwiper")' slot="button-prev">
              <i class="el-icon-arrow-right" style="color: #fff;"></i>
            </div>
            <div class="swiper-button-prev" @click='swiperPrev("myHonorSwiper")' slot="button-next">
              <i class="el-icon-arrow-left" style="color: #fff;" ></i>
            </div>

          </swiper>

        </div>

      </div>

      <div v-if="isShowHonor && homeHonorList.length > 0" class="honor-block" style="width: 32rem">
        <!-- 标题 -->
        <div class="info-title-block">
          <div class="img-title">
            <img src="../assets/img/honor.png" class="info-title-img" alt="" />
            <div class="info-title cur-pointer" @click="toHonorDetail(1)">
              <span>学校荣誉</span>
            </div>
          </div>
          <div class="info-title-more cur-pointer" @click="toHonorDetail(1)">
            <span>更多 ></span>
          </div>
        </div>
        <!-- 虚线 -->
        <div class="blue-line"></div>
        <div class="honor-content">
<!--          <el-carousel :height="honorSwiperHeight2 + 'px'"  class="honor-carousel-block" indicator-position="none">-->
<!--            <el-carousel-item-->
<!--                v-for="(item, index) in homeHonorList"-->
<!--                :key="index"-->
<!--                class="honor-carousel-item"-->
<!--            >-->
<!--              <div-->
<!--                  class="honor-item cur-pointer"-->
<!--                  @click="toHonorDetail(2, item, index)"-->
<!--              >-->
<!--                <div :span="24" class="honor-item-img">-->
<!--                  <img @load="honorImgLoad2" ref="honorImgRef2" :src="imgserver + item.picUrl" alt="" />-->
<!--                  <span>{{item.name}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->

          <swiper v-if="homeHonorList.length > 0" :options="swiperHonorOption2" ref="myHonorSwiper2" class="honor-swiper" :style="{height: honorSwiperHeight2 + 'px'}"  >
            <swiper-slide   v-for="(item, index) in homeHonorList" :key="'honor2-' + index"  :index="'college' + index"  >

              <div  class="honor-carousel-block">
                <div class="honor-carousel-item" >
                  <div
                      class="honor-item cur-pointer"
                      @click="toHonorDetail(2, item, index)"
                  >
                    <div :span="24" class="honor-item-img">
                      <img ref="honorImgRef2" @load="honorImgLoad2" style="width: 100%;height: 100%;object-fit: fill;" :src="imgserver + item.picUrl" alt="" />
                      <span>{{item.title}}</span>
                    </div>
                  </div>
                </div>
              </div>

            </swiper-slide>

            <div class="swiper-button-next" @click='swiperNext("myHonorSwiper2")' slot="button-prev">
              <i class="el-icon-arrow-right" style="color: #fff;"></i>
            </div>
            <div class="swiper-button-prev" @click='swiperPrev("myHonorSwiper2")' slot="button-next">
              <i class="el-icon-arrow-left" style="color: #fff;" ></i>
            </div>

          </swiper>


        </div>
      </div>

    </el-col>

    <div
        class="common-block"
        v-if="isShowFriendLink && homeOftenLinksList.length > 0"
    >
      <div class="common-line">
        <div class="img-title">
          <div class="common-line-logo">
            <img
                style="width: 100%; height: 100%"
                src="../assets/img/friendLink.png"
                alt=""
            />
          </div>
          <div class="common-line-title">
            <span>常用链接</span>
          </div>
        </div>
        <div class="blue-line"></div>
      </div>
      <div class="common-link-content" justify="space-between">
        <div
            v-for="(item, index) in homeOftenLinksList"
            :key="index"
            class="common-link-item cur-pointer"
            @click="toOftenLinkDetail(2, item)"
        >
          <div class="common-link-item-block">
            <img
                :src="imgserver + item.icon"
                alt=""
                style="width: 100%;height: 100%;object-fit: fill"
            />
          </div>
        </div>
      </div>
    </div>

    <div
        class="common-block"
        v-if="isShowFriendLink && homeFriendLinksList.length > 0"
    >
      <div class="common-line">
        <div class="img-title">
          <div class="common-line-logo">
            <img
                style="width: 100%; height: 100%"
                src="../assets/img/friendLink.png"
                alt=""
            />
          </div>
          <div class="common-line-title">
            <span>友情链接</span>
          </div>
        </div>
        <div class="blue-line"></div>
      </div>
      <div class="common-link-content" justify="space-between">
        <div
            v-for="(item, index) in homeFriendLinksList"
            :key="index"
            class="common-link-item cur-pointer"
            @click="toFriendLinkDetail(2, item)"
        >
          <div class="friendship-link-item-icon">
            <img
                style="width: 100%; height: 100%"
                :src="imgserver + item.picUrl"
            />
          </div>
        </div>
      </div>
    </div>
  </el-row>
</template>

<script>
import {
  getBannerListApi,
  getFunctionListApi,
  getDataListApi,
  getHomeFriendLinksListApi,
  getHomeHonorListApi,
  getHomeImagesListApi,
  getHomeNewsListApi,
  getHomeNoticeListApi,
  getHomeOftenLinksListApi,
  getHomeSubjectListApi,
} from "@/api/homeApi";

import 'swiper/dist/css/swiper.css'
import { swiper,swiperSlide } from 'vue-awesome-swiper'
import shareMethods from "@/common/shareMethods";

let _self = null;

export default {
  name: "home",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      pcShowBool: true,
      funcId: "1",
      bannerList: [],
      dataList: [],
      functionList: [],
      homeFriendLinksList: [],
      homeHonorList: [],
      homeImagesList: [],
      homeNewsList: [],
      homeNewsBannerList: [],
      homeNoticeList: [],
      homeOftenLinksList: [],
      homeSubjectList: [],
      newsSolidList: [],
      isShowStudent: false,
      isShowIntroduce: false,
      isShowInfoPublic: false,
      isShowImageCenter: false,
      isShowHonor: false,
      isShowOftenLink: false,
      isShowFriendLink: false,
      oftenLinkInterval: "",
      friendLinkInterval: "",
      bannerHeight: 34,
      homeNewsHeight: 43,
      swiperOption: {
        init:false,
        autoHeight: true,
        initialSlide:0,
        loopAdditionalSlides: 5,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        pagination:{
          el:'.swiper-pagination',
          nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
          clickable: true, // 允许点击小点直接切换

        },
        // notNextTick:true,
        autoplay: {
          disableOnInteraction: false,
        } ,
        loop: true,
        on: {
          click(e){
            if(e.target.className === "el-image__inner"){
              if(_self.bannerList[this.realIndex] && _self.bannerList[this.realIndex].jumpPage){
                window.open(_self.bannerList[this.realIndex].jumpPage,"_blank")
              }
            }

          }
        }

      },
      swiperCollegeOption: {
        init:false,
        initialSlide:0,
        loopAdditionalSlides: 5,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        pagination:{
          nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。

        },
        // notNextTick:true,
        autoplay: {
          disableOnInteraction: false,
        } ,
        loop: true,
        on: {
          click: function (){
            const realIndex = this.realIndex ; //这里的this指向swiper
            _self.toBannerDetail(_self.homeNewsBannerList[realIndex])
          }
        }
      },
      swiperHonorOption: {
        init:false,
        initialSlide:0,
        loopAdditionalSlides: 5,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        pagination:{
          el:'.swiper-pagination',
          nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
          clickable: true, // 允许点击小点直接切换
        },
        // notNextTick:true,
        autoplay: {
          disableOnInteraction: false,
        } ,
        loop: true,
        effect : 'fade',
        fadeEffect: {
          crossFade: true,
        },
        on: {

        }
      },
      swiperHonorOption2: {
        init:false,
        initialSlide:0,
        loopAdditionalSlides: 5,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        pagination:{
          el:'.swiper-pagination',
          nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
          clickable: true, // 允许点击小点直接切换
        },
        // notNextTick:true,
        autoplay: {
          disableOnInteraction: false,
        } ,
        loop: true,
        effect : 'fade',
        fadeEffect: {
          crossFade: true,
        },
        on: {

        }
      },
      honorSwiperHeight: 0,
      honorSwiperHeight2: 0,


    };
  },
  created() {

    _self = this;


    this.$nextTick(() => {
      let imgUrl = "https://www.csysedu.com/favicon.png";
      let linkUrl = window.location.href ;
      let desc = "长沙市唯上商务科技学校";
      let title = "长沙市唯上商务科技学校";
      this.share(imgUrl, linkUrl,desc, title );


    })

    getBannerListApi(this.funcId).then((res) => {
      this.bannerList = res.data;

      this.swiperOption.autoplay = this.bannerList.length == 1?false:true;

      setTimeout(() => {
        this.$nextTick(() => {
          // 确保DOM更新后初始化Swiper
          this.swiper.init();

        });
      }, 500)
    });
    getDataListApi(1, 10, this.funcId).then((res) => {
      this.dataList = res.rows;
    });
    getFunctionListApi(this.funcId).then((res) => {
      this.functionList = res.data;
      this.functionList.forEach((item) => {
        if (item.id == 25) {
          this.isShowStudent = true;
        }
        if (item.id == 26) {
          this.isShowIntroduce = true;
        }
        if (item.id == 27) {
          this.isShowInfoPublic = true;
        }
        if (item.id == 28) {
          this.isShowImageCenter = true;
        }
        if (item.id == 29) {
          this.isShowHonor = true;
        }
        if (item.id == 30) {
          this.isShowOftenLink = true;
        }
        if (item.id == 31) {
          this.isShowFriendLink = true;
        }
      });
    });
    getHomeFriendLinksListApi().then((res) => {
      var datalist = res.rows;
      let index = 0;
      var tempDataList = datalist.concat(datalist);
      if (datalist.length > 4) {
        this.clearFriendLinkInterval();
        this.friendLinkInterval = setInterval(() => {
          index = index < datalist.length ? index : 0;
          this.homeFriendLinksList = tempDataList.slice(index, index + 4);
          index++;
        }, 3000);
      } else {
        this.homeFriendLinksList = res.rows;
      }
    });
    getHomeHonorListApi(1, 10).then((res) => {
      this.homeHonorList = res.rows;

      setTimeout(() => {
        this.$nextTick(() => {
          // 确保DOM更新后初始化Swiper
          this.swiperHonor2.init();

        });
      }, 500)

    });

    getHomeImagesListApi(1, 10).then((res) => {
      this.homeImagesList = res.rows;

      setTimeout(() => {
        this.$nextTick(() => {
          // 确保DOM更新后初始化Swiper
          this.swiperHonor.init();

        });
      }, 500)

    });
    getBannerListApi(33).then((res) => {
      this.homeNewsBannerList = res.data;

      setTimeout(() => {
        this.$nextTick(() => {
          // 确保DOM更新后初始化Swiper
          this.swiperCollege.init();

        });
      }, 500)

    });
    getHomeNewsListApi(1, 10).then((res) => {
      this.homeNewsList = res.rows.slice(0,8);
    });
    getHomeNoticeListApi(1, 10).then((res) => {
      this.homeNoticeList = res.rows;
    });
    getHomeOftenLinksListApi().then((res) => {
      var datalist = res.rows;
      let index = 0;
      var tempDataList = datalist.concat(datalist);
      if (datalist.length > 4) {
        this.clearOfterLinkInterval();
        this.oftenLinkInterval = setInterval(() => {
          index = index < datalist.length ? index : 0;
          this.homeOftenLinksList = tempDataList.slice(index, index + 4);
          index++;
        }, 3000);
      } else {
        this.homeOftenLinksList = res.rows;
      }
    });
    getHomeSubjectListApi(1, 10).then((res) => {
      this.homeSubjectList = res.rows;
    });
    this.handleResize();
  },
  mixins: [shareMethods],
  methods: {
    clearOfterLinkInterval() {
      this.oftenLinkInterval && clearInterval(this.oftenLinkInterval);
    },
    clearFriendLinkInterval() {
      this.friendLinkInterval && clearInterval(this.friendLinkInterval);
    },

    onlineSign() {
      // 跳转在线报名自定义表单
      this.$router.push({
        path: "/fillCustomForm?id=LUnHIKxpE6i7fu2RDgAw8A==",
      });
    },

    handleResize() {
      var html = document.getElementsByTagName("html")[0];
      var oWidth =
          document.body.clientWidth || document.documentElement.clientWidth;
      // 这里的750是指设计图的大小,自己根据实际情况改变
      html.style.fontSize = (oWidth / 1440) * 10 + "px";
      if (oWidth >= 992) {
        // 600到1024像素之间的样式处理
        this.pcShowBool = true;
      }
      if (oWidth < 1439) {
        // 600到1439像素之间的样式处理
        this.bannerHeight = 40.8;
        this.homeNewsHeight = 60;
      } else {
        this.bannerHeight = 34;
        this.homeNewsHeight = 43;
      }
      if (oWidth < 992) {
        // 600到1439像素之间的样式处理
        this.homeNewsHeight = 110;
        this.pcShowBool = false;
      }
      if (oWidth < 768) {
        this.homeNewsHeight = 116;
      }
      if (oWidth < 500) {
        this.homeNewsHeight = 120;
      }
    },
    // 导航栏跳转
    toNewDetail(type, item) {
      if (item && item.source) {
        window.open(item.source, "_blank");
      } else {
        if (type == 1) {
          this.$router.push({
            path: "/newsCenter",
          });
        } else if (type == 2) {
          this.$router.push({
            path: "/newsCenter",
            query: { id: item.funcId, type: 2, newsId: item.id },
          });
        }
      }
    },
    toLinkMore(type) {
      this.$router.push({
        path: "/linkCenter",
        query: { type: type },
      });
    },
    toSubjectDetail(type, item, index) {
      if (type == 1) {
        this.$router.push({
          path: "/subjectCenter",
        });
      } else if (type == 2) {
        item.funcId = 14;
        this.$router.push({
          path: "/studentAndJob",
          query: { id: item.funcId, type: 2, newsId: 27 },
        });
      }
    },
    toIntroduceDetail(type, item) {
      if (item && item.source) {
        window.open(item.source, "_blank");
      } else {
        if (type == 1) {
          this.$router.push({
            path: "/newsCenter",
          });
        } else if (type == 2) {
          this.$router.push({
            path: "/newsCenter",
            query: { id: item.funcId, type: 2, index: index },
          });
        }
      }
    },
    toOftenLinkDetail(type, item) {
      if (item && item.jumpPage) {
        window.open(item.jumpPage, "_blank");
      }
    },
    toFriendLinkDetail(type, item) {
      if (item && item.jumpPage) {
        window.open(item.jumpPage, "_blank");
      }
    },
    toFriendLink(item) {
      if (item.source) {
        window.open(item.jumpPage, "_blank");
      }
    },
    toBannerDetail(item) {
      if (item && item.jumpPage) {
        window.open(item.jumpPage, "_blank");
      }
    },
    toImageCenter(type, item, index) {
      if (type == 1) {
        this.$router.push({
          path: "/imageCenter",
        });
      } else if (type == 2) {
        this.$router.push({
          path: "/imageCenter",
          query: { id: item.funcId, type: 2, index: index },
        });
      }
    },
    toHonorDetail(type, item, index) {
      if (item && item.jumpPage) {
        window.open(item.jumpPage, "_blank");
      } else {
        if (type == 1) {
          this.$router.push({
            path: "/honorCenter",
          });
        } else if (type == 2) {
          this.$router.push({
            path: "/honorCenter",
            query: { item: item, type: 2, index: index },
          });
        }
      }
    },

    toPublicInfo(type, item, index) {
      if (type == 1) {
        this.$router.push({
          path: "/infoPublic",
        });
      } else if (type == 2) {
        this.$router.push({
          path: "/infoPublic",
          query: { id: item.funcId, type: 2, index: index, newsId: item.id },
        });
      }
    },

    swiperNext(swiperName) {
      this.$refs[swiperName].swiper.slideNext()
    },
    swiperPrev(swiperName) {
      this.$refs[swiperName].swiper.slidePrev()
    },

    honorImgLoad(e){
      this.$nextTick(() => {
        console.log("this.$refs.honorImgRef.offsetHeight: " , this.$refs.honorImgRef[0].offsetHeight)
        this.honorSwiperHeight = this.$refs.honorImgRef[0].offsetHeight + 10 ;
      })
    },
    honorImgLoad2(e){
      this.$nextTick(() => {
        console.log("this.$refs.honorImgRef2.offsetHeight: " , this.$refs.honorImgRef2[0].offsetHeight)
        this.honorSwiperHeight2 = this.$refs.honorImgRef2[0].offsetHeight + 10 ;
      })
    }

  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    swiperCollege() {
      return this.$refs.myCollegeSwiper.swiper;
    },
    swiperHonor() {
      return this.$refs.myHonorSwiper.swiper;
    },
    swiperHonor2() {
      return this.$refs.myHonorSwiper2.swiper;
    }
  },
  beforeDestroy() {
    this.clearFriendLinkInterval();
    this.clearOfterLinkInterval();
    _self = null;
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);



  },
};
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}

.background-image {
  margin: 0 12rem;
  min-width: 120rem; /* 设置div的宽度 */
  height: 100%; /* 设置div的高度 */
  background-clip: content-box;
  background-repeat: no-repeat;
  background-position: center; /* 背景图片居中 */
  color: #fff;
  background-size: 100% 100%;
}


::v-deep .el-carousel__indicators {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.banner-block {
  display: flex;
  flex-direction: column;
  position: relative;
  .background-image-bgbox{
    width: 100%;
    height: auto;
    .background-image-bg{
      width: 100%;
      position: relative;
    }
  }


  .swiper-info-box{
    padding: 0 0 0 120px;
    position: absolute;
    bottom: 85px;
    z-index: 60;
    .carousel_title {
      display: inline-block;
      font-size: 40px;
      min-height: 52px;
      width: 60%;
      line-height: normal;
      font-weight: 700;
    }

    .carousel_remark{
      display: inline-block;
      width: 27%;
    }

    .carousel_description {
      margin: 6px 0 0 0px;
      font-size: 18px;
      width: 90vw;
      line-height: normal;
      min-height: 32px;
      font-weight: 400;
    }

    .carousel_details{
    }

    .carousel_button {
      margin: 16px 0 0 50px;
      font-size: 14px;
      width: 160px;
      min-height: 52px;
      font-weight: 400;
      position: absolute;
    }
  }


}

.background-image::after {
  width: 100%;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--bgImage);
  background-size: 100% 100%;
  opacity: 1; /* 设置透明度 */
  z-index: -1; /* 确保伪元素在背 下 */
}

.online-sign {
  width: 120rem;
  margin: 12px 12rem 0;
  height: 18.5rem;
}

.contain-block {
  margin: 40px 12rem 0px 12rem;
  width: 120rem;
  .college-news {
    display: flex;
    justify-content: space-between;
    .college-news-title {
      font-size: 31px;
      font-weight: 600;
      margin-left: 40px;
      width: 200px;
    }

    .college-news-more {
      margin-right: 10px;
      margin-top: 10.5px;
      font-size: 16px;
      font-weight: 600;
      height: 22px;
      color: #55768c;
    }
  }
}

.text-more {
  font-size: 16px;
  height: 22px;
  color: #55768c;
  font-weight: 600;
}

.blue-line {
  border: 2px solid #005379;
  margin: 16px 0 20px 0;
}

.gray-line {
  border: 0.2px solid #e8e8ea;
}

.college-news-content {
  width: 100%;
  min-width: 1200px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .college-news-carouse {
    width: 49.5rem;
    .college-news-carouse-item{
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      .college-news-carousel-img {
        width: 100%;
        height: calc(18.9rem + 66px + 66px + 66px + 66px ) !important;
      }
      .college-news-carousel-title {
        display: flex;
        flex-direction: row;
        justify-content: center;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 100px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 97%);
        span{
          margin-top: 66px;
          font-family: Source Han Sans CN;
          font-size: 16px;
          font-weight: 500;
          line-height: normal;
          text-align: center;
          letter-spacing: 0.1em;

          font-variation-settings: "opsz" auto;
          color: #FFFFFF;

          text-shadow: 0px 0px 10px #000000;
        }
      }
    }

  }
}

.college-new-content-block {
  width: 68.1rem;
  margin-left: 2.4rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  .college-new-content-block-list {
    :not(:nth-child(1)):not(:nth-child(2)) {
      height: 66px;
    }
    width: 32.85rem;
    .college-news-content-img {
      height: 18.9rem !important;
    }
    &:nth-child(odd) {
      margin-right: 2.3rem;
    }
    .college-news-content-article {
      display: flex;
      flex-direction: column;
      height: 66px;
      justify-content: space-between;
      align-content: center;
      .college-news-article-block {
        width: 76px;
        //height: 40px;
        background-color: #f7f7f7;
        .article-block-img {
          width: 16px;
          height: 16px;
          img {
            width: 100%;
            height: 100%;
            margin: 6px 0 0 30px;
          }
        }
        .article-block-calendar {
          width: 40px;
          height: 15px;
          font-size: 11px;
          font-weight: 400;
          margin: 8px 20px;
        }
      }
      .college-news-content-title {
        display: flex;
        flex: 1;
        align-items: center;
        div{
          line-height: 20px;
          margin: 0px 0 0px 8px;
          font-size: 16px;
          font-weight: 400;
          color: #050d3e;
          // white-space: normal !important;
          display: -webkit-box; /* 将p标签变成弹性盒子 */
          -webkit-line-clamp: 2; /* 最多显示2行 */
          -webkit-box-orient: vertical; /* 垂直排列 */
          overflow: hidden; /* 超出部分隐藏 */
          text-overflow: ellipsis; /* 显示省略号 */
        }
      }
    }
  }
  :not(:nth-child(1)):not(:nth-child(2)) {
    height: 66px;
  }
}

.introduce-imgs-content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 2rem;
  .introduce-imgs-item {
    width: 38rem;
    height: 12.2rem;
  }
}

.info-image-Honor {
  display: flex;
  width: 120rem;
  flex-direction: row;
  justify-content: start;
  margin: 40px 12rem 0 12rem;
  .info-block {
    display: flex;
    flex-direction: column;
    margin-right: 2rem;
    width: 42rem;
    &:last-child {
      margin-right: 0;
    }
    .info-title-block {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .img-title {
        display: flex;
        flex-direction: row;
        .info-title-img {
          width: 32px;
          height: 32px;
          margin: 6px 10px 0 0;
        }
        .info-title {
          font-size: 31px;
          font-weight: 600;
        }
      }
      .info-title-more {
        font-size: 16px;
        font-weight: 600;
        margin: 12px 0 0 0;
        color: #5c758a;
      }
    }
    .blue-line {
      width: 42rem;
      border: 2px solid #0e517a;
      margin: 16px 0 24px 0;
    }
    .info-content {
      .info-content-item {
        width: 42rem;
        height: 20.7px;
        display: flex;
        justify-content: space-between;
        margin: 0 0 16px 0;
        align-items: center;
        .dot-title {
          display: flex;
          width: 36rem;
          .info-content-dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin: 6px 8px 0 0;
            background-color: #d8d8d8;
          }

          .info-content-title {
            font-size: 16px;
            font-weight: 400;
            width: 32rem;
          }
        }
        .info-content-time {
          font-size: 16px;
          font-weight: 400;
          color: #6e728a;
          white-space: nowrap;
        }
      }
    }

    .honor-content {

      .honor-swiper{

        .swiper-slide{
          transition-duration: 850ms !important;
        }

        &:hover {

          :deep(.swiper-button-prev){
            display: flex !important;
            width: 36px;
            height: 36px;
            top: 50%;
            transform: translateY(-50%);
            opacity: 1;
            background: rgba(0,0,0,0.1);
            .el-icon-arrow-left{
              width: auto;
              height: auto;
              display: inline-block;
            }
          }

          :deep(.swiper-button-next){
            display: flex !important;
            width: 36px;
            height: 36px;
            top: 50%;
            border-radius: 18px;
            transform: translateY(-50%);
            background: rgba(0,0,0,0.1);
            opacity: 1;
            .el-icon-arrow-right{
              width: auto;
              height: auto;
              display: inline-block;
            }
          }

        }

        :deep(.swiper-button-prev){

          //display: none !important;
          transition: all 0.2s ease-in-out;
          width: 0px;
          height: 0px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: normal;
          border-radius: 18px;
          background: rgba(0,0,0,0);
          opacity: 0;
          top: 50%;
          transform: translateY(-50%);

          &:after {
            font-size: 1.1rem;
            color: #fff;

          }

          .el-icon-arrow-left{
            width: 0;
            height: 0;
            display: none;
          }

        }

        :deep(.swiper-button-next){

          //display: none !important;
          transition: all 0.2s ease-in-out;
          width: 0px;
          height: 0px;
          display: flex;
          opacity: 0;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: normal;
          border-radius: 1.8rem;
          background: rgba(0,0,0,0);
          top: 50%;
          transform: translateY(-50%);
          &:after {
            font-size: 1.1rem;
            color: #fff;

          }

          .el-icon-arrow-right{
            width: 0;
            height: 0;
            display: none;
          }

        }

      }

      .honor-carousel-block {
        .honor-carousel-item {
          .honor-item-img {
            height: 280px;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;


            img {
              width: 100%;
              height: 100%;
              object-fit: fill;
            }

            span{
              position: absolute;
              bottom: 15px;
              font-family: Source Han Sans CN;
              font-size: 16px;
              font-weight: 500;
              line-height: normal;
              text-align: center;
              letter-spacing: 0.1em;

              font-variation-settings: "opsz" auto;
              color: #FFFFFF;

              text-shadow: 0px 0px 10px #000000;
            }

          }
        }

      }
    }

  }

  .honor-block {
    display: flex;
    flex-direction: column;
    margin-right: 0rem;
    .info-title-block {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 32rem;
      .img-title {
        display: flex;
        flex-direction: row;
        .info-title-img {
          width: 32px;
          height: 32px;
          margin: 6px 10px 0 0;
        }
        .info-title {
          font-size: 31px;
          font-weight: 600;
        }
      }
      .info-title-more {
        font-size: 16px;
        font-weight: 600;
        margin: 12px 0 0 0;
        color: #5c758a;
      }
    }
    .blue-line {
      width: 32rem;
      border: 2px solid #0e517a;
      margin: 16px 0 24px 0;
    }

    .honor-content {

      .honor-swiper{

        .swiper-slide{
          transition-duration: 850ms !important;
        }

        &:hover {

          :deep(.swiper-button-prev){
            display: flex !important;
            width: 36px;
            height: 36px;
            top: 50%;
            transform: translateY(-50%);
            opacity: 1;
            background: rgba(0,0,0,0.1);
            .el-icon-arrow-left{
              width: auto;
              height: auto;
              display: inline-block;
            }
          }

          :deep(.swiper-button-next){
            display: flex !important;
            width: 36px;
            height: 36px;
            top: 50%;
            border-radius: 18px;
            transform: translateY(-50%);
            background: rgba(0,0,0,0.1);
            opacity: 1;
            .el-icon-arrow-right{
              width: auto;
              height: auto;
              display: inline-block;
            }
          }

        }

        :deep(.swiper-button-prev){

          //display: none !important;
          transition: all 0.2s ease-in-out;
          width: 0px;
          height: 0px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: normal;
          border-radius: 18px;
          background: rgba(0,0,0,0);
          opacity: 0;
          top: 50%;
          transform: translateY(-50%);

          &:after {
            font-size: 1.1rem;
            color: #fff;

          }

          .el-icon-arrow-left{
            width: 0;
            height: 0;
            display: none;
          }

        }

        :deep(.swiper-button-next){

          //display: none !important;
          transition: all 0.2s ease-in-out;
          width: 0px;
          height: 0px;
          display: flex;
          opacity: 0;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: normal;
          border-radius: 1.8rem;
          background: rgba(0,0,0,0);
          top: 50%;
          transform: translateY(-50%);
          &:after {
            font-size: 1.1rem;
            color: #fff;

          }

          .el-icon-arrow-right{
            width: 0;
            height: 0;
            display: none;
          }

        }

      }

      .honor-carousel-block {
        .honor-carousel-item {
          .honor-item {
            .honor-item-img {
              height: 280px;
              display: flex;
              flex-direction: column;
              align-items: center;
              position: relative;
              img {
                width: 100%;
                height: 100%;
                object-fit: fill;
              }

              span{
                position: absolute;
                bottom: 15px;
                font-family: Source Han Sans CN;
                font-size: 16px;
                font-weight: 500;
                line-height: normal;
                text-align: center;
                letter-spacing: 0.1em;

                font-variation-settings: "opsz" auto;
                color: #FFFFFF;

                text-shadow: 0px 0px 10px #000000;
              }

            }
          }
        }
      }
    }
  }
}

.common-block {
  display: flex;
  width: 120rem;
  flex-direction: column;
  justify-content: start;
  margin: 40px 12rem 0 12rem;
  .common-line {
    display: flex;
    flex-direction: column;
    width: 120rem;
    .img-title {
      display: flex;
      flex-direction: row;
      .common-line-logo {
        width: 32px;
        height: 32px;
        margin: 6px 10px 0 0;
      }
      .common-line-title {
        font-size: 31px;
        font-weight: 600;
      }
    }

    .blue-line {
      width: 120rem;
      border: 2px solid #0e517a;
      margin: 16px 0 24px 0;
      box-sizing: border-box;
    }
  }
  .common-link-content {
    display: flex;
    flex-direction: row;
    justify-content: start;
    .common-link-item {
      width: 28.5rem;
      // height: 72px;
      display: flex;
      justify-content: space-between;
      margin: 0 2rem 16px 0;
      &:last-child {
        margin-right: 0;
      }
      .friendship-link-item-icon {
        width: 100%;
        height: 100%;
      }
      .common-link-item-block {
        width: 100%;
        background-color: #e8e8ea;
      }
    }
  }
}

.html-block {
  border: 1px solid #f1f1f1;
}


@media only screen and (min-width: 1921px) {
  .info-image-Honor {
    .info-block {
      .honor-carousel-block {
        .honor-carousel-item {
          .honor-item-img {
            img {

              object-fit: cover !important;
            }
          }
        }
      }


    }


    .honor-block {
      .honor-carousel-block {
        .honor-carousel-item {
          .honor-item-img {
            img {

              object-fit: cover !important;
            }
          }
        }
      }
    }

  }






}

@media only screen and (max-width: 1920px) {


}

@media only screen and (max-width: 1439px) {
  .banner-block {
    display: flex;
    flex-direction: column;

    .swiper-info-box{
      margin: 16rem 0 0 50px;
      position: absolute;
      z-index: 60;
      .carousel_title {

        font-size: 40px;
        min-height: 52px;
        width: 90vw;
        line-height: normal;
        font-weight: 700;
      }
      .carousel_description {
        margin: 6px 0 0 50px;
        font-size: 18px;
        width: 90vw;
        line-height: normal;
        min-height: 32px;
        font-weight: 400;
      }
      .carousel_button {
        margin: 12px 0 0 50px;
      }

    }


  }
  .background-image {
    width: 100%;
    min-width: 0;
    max-width: 1200px; /* 设置div的宽度 */
    margin: 0 auto;
    height: 100%; /* 设置div的高度 */
  }

  .contain-block {
    width: 120rem;
    min-width: 0;
    max-width: 1200px; /* 设置div的宽度 */
    margin: 40px 12rem 0 12rem;
  }

  .college-news-content {
    justify-content: space-between;
    min-width: 66.3rem;
    .college-news-carouse {
      width: 63.1rem;
      .college-news-carousel-img {
        width: 63.1rem;
        height: 50rem;
      }
      .college-news-carousel-title {
        font-size: 16px;
        font-weight: 400;
        height: 22px;
        line-height: 20px;
        margin-top: 12px;
        width: 63.1rem;
      }
    }
    .college-new-content-block {
      width: 50rem;
      min-width: 0;
      flex-wrap: wrap;
      margin-left: 0;
      .college-new-content-block-list {
        width: 50rem;
        .college-news-content-article {
          .college-news-content-title {
            width: 50rem;
          }
        }
        &:nth-child(odd) {
          margin-right: 0px;
        }
        .college-news-content-img {
          display: none;
        }
      }
    }
  }
}
@media only screen and (max-width: 1330px) {
}
@media only screen and (max-width: 1200px) {
  .college-news-content {
    .college-new-content-block {
      .college-new-content-block-list {
        .college-news-content-img {
          height: 30rem;
        }
      }
    }
  }
}
@media only screen and (max-width: 992px) {

  .my-swiper-box{
    .custom-carousel{
      :deep(.swiper-button-prev){
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        top: 50%;
        transform: translateY(-50%);
        opacity: 1;
        background: rgba(0,0,0,0.3);
        .el-icon-arrow-left{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

      :deep(.swiper-button-next){
        display: flex !important;
        width: 36px;
        height: 36px;
        top: 50%;
        border-radius: 18px;
        transform: translateY(-50%);
        background: rgba(0,0,0,0.3);
        opacity: 1;
        .el-icon-arrow-right{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

    }

  }


  .banner-block {
    .swiper-info-box {
      margin: 8rem 0 0 38px;
      position: absolute;
      z-index: 60;
      .carousel_title {
        margin: 8rem 0 0 38px;
        font-size: 32px;
        width: 90vw;
        min-height: 0px;
      }
      .carousel_description {
        margin: 6px 0 0 38px;
        font-size: 18px;
        height: 32px;
      }
      .carousel_button {
        margin: 16px 0 0 38px;
        font-size: 14px;
        min-height: 42px;
      }
    }

  }
  .college-news-content {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: nowrap;
    height: auto;
    .college-news-carouse {
      width: 120rem;
      .el-carousel__container {
        .el-carousel__item {
          ::v-deep .cur-pointer {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          }
        }
      }
      .college-news-carousel-img {
        width: 120rem;
        height: 95.1rem;
      }
      .college-news-carousel-title {
        font-size: 14px;
        font-weight: 400;
        height: 22px;
        line-height: 20px;
        margin-top: 12px;
        width: 120rem;
      }
    }
    .college-new-content-block {
      margin-top: 10px;
      width: 100rem;
      // margin-top: 40px;
      .college-new-content-block-list {
        width: 120rem;
        .college-news-content-article {
          width: 120rem;
          .college-news-content-title {
            width: 120rem;
            height: 40px;
            margin-left: 8px;
            font-size: 14px;
            font-weight: 400;
            color: #050d3e;
          }
        }
      }
    }
  }

  .introduce-imgs-content {
    flex-direction: column;
    .introduce-imgs-item {
      width: 120rem;
      height: 20.2rem;
      margin-top: 20px;
      &:first-child {
        margin-top: 0;
      }
    }
  }

  .info-image-Honor {
    flex-direction: column;
    justify-content: center;
    .info-block {
      flex-direction: column;
      margin-right: 0rem;
      width: 120rem;
      &:last-child {
        margin-right: 0;
      }
      .info-title-block {
        .img-title {
          .info-title-img {
          }
          .info-title {
          }
        }
        .info-title-more {
        }
      }
      .blue-line {
        width: 120rem;
      }

      .info-content {
        .info-content-item {
          width: 120rem;
          .dot-title {
            width: 100rem;
            .info-content-dot {
            }
            .info-content-title {
              width: 90rem;
              font-size: 14px;
            }
          }
          .info-content-time {
            font-size: 14px;
          }
        }
      }

      .honor-content {
        .honor-carousel-block {
          .honor-carousel-item {
            .honor-item-img {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              position: relative;
              img {
                width: 100%;
                height: 100%;
                object-fit: fill;
              }

              span{
                position: absolute;
                bottom: 15px;
                font-family: Source Han Sans CN;
                font-size: 16px;
                font-weight: 500;
                line-height: normal;
                text-align: center;
                letter-spacing: 0.1em;

                font-variation-settings: "opsz" auto;
                color: #FFFFFF;

                text-shadow: 0px 0px 10px #000000;
              }

            }
          }
        }
      }

    }

    .honor-block {
      display: flex;
      flex-direction: column;
      margin-right: 0rem;
      .info-title-block {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 120rem;
        .img-title {
          display: flex;
          flex-direction: row;
          .info-title-img {
            width: 32px;
            height: 32px;
            margin: 6px 10px 0 0;
          }
          .info-title {
            font-size: 31px;
            font-weight: 600;
          }
        }
        .info-title-more {
          font-size: 16px;
          font-weight: 600;
          margin: 12px 0 0 0;
          color: #5c758a;
        }
      }
      .blue-line {
        width: 120rem;
      }

      .honor-content{
        width: 120rem;
      }

      .honor-content {
        .honor-carousel-block {
          .honor-carousel-item {
            .honor-item-img {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              position: relative;
              img {
                width: 100%;
                height: 100%;
                object-fit: fill;
              }

              span{
                position: absolute;
                bottom: 15px;
                font-family: Source Han Sans CN;
                font-size: 16px;
                font-weight: 500;
                line-height: normal;
                text-align: center;
                letter-spacing: 0.1em;

                font-variation-settings: "opsz" auto;
                color: #FFFFFF;

                text-shadow: 0px 0px 10px #000000;
              }

            }
          }
        }
      }

    }
  }

  .common-block {
    .common-link-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .common-link-item {
        width: 120rem;
        //height: 20rem;
        display: flex;
        margin: 0 2rem 16px 0;
        &:last-child {
          margin-right: 0;
        }
        .friendship-link-item-icon {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media only screen and (max-width: 768px) {

  .my-swiper-box{
    .custom-carousel{
      :deep(.swiper-button-prev){
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        top: 50%;
        transform: translateY(-50%);
        opacity: 1;
        background: rgba(0,0,0,0.3);
        .el-icon-arrow-left{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

      :deep(.swiper-button-next){
        display: flex !important;
        width: 36px;
        height: 36px;
        top: 50%;
        border-radius: 18px;
        transform: translateY(-50%);
        background: rgba(0,0,0,0.3);
        opacity: 1;
        .el-icon-arrow-right{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

    }

  }


  .breadcrumb-search {
    width: 128rem;
    margin: 20px 8rem 20px 8rem;
    .search-block {
      width: 128rem;
    }
  }

  .banner-block {

    .swiper-info-box {
      margin: 6rem 0 0 38px;
      position: absolute;
      z-index: 60;
      .carousel_title {
        margin: 6rem 0 0 38px;
        font-size: 20px;
        width: 90vw;
      }
      .carousel_description {
        margin: 6px 0 0 38px;
        font-size: 14px;
        min-height: 20px;
        line-height: 20px;
      }
      .carousel_button {
        margin: 10px 0 0 38px;
        font-size: 12px;
        width: 120px;
        max-height: 22px;
      }

    }

  }

  .online-sign {
    width: 128rem;
    margin: 12px 8rem 0;
    height: 20.5rem;
  }

  .contain-block {
    margin: 20px 8rem 0 8rem;
    width: 128rem;
    .college-news {
      display: flex;
      justify-content: space-between;
      .college-news-title {
        font-size: 16px;
        font-weight: 600;
        margin-left: 20px;
        width: 120px;
      }

      .college-news-more {
        margin-right: 0px;
        margin-top: 2px;
        font-size: 12px;
        font-weight: 600;
        height: 22px;
        color: #55768c;
      }
    }
  }
  .info-image-Honor {
    width: 128rem;
    margin: 20px 8rem 0;
    .info-block {
      width: 128rem;
      &:last-child {
        margin-right: 0;
      }
      .info-title-block {
        .img-title {
          .info-title-img {
            width: 20px;
            height: 20px;
          }
          .info-title {
            font-size: 16px;
            margin-top: 4px;
          }
        }
        .info-title-more {
          font-size: 12px;
          margin-top: 6px;
          color: #55768c;
        }
      }
      .blue-line {
        width: 128rem;
      }


      .info-content {
        width: 128rem;
        .info-content-item {
          width: 128rem;
          .dot-title {
            width: 110rem;
            .info-content-title {
              width: 100rem;
            }
          }
          .info-content-time {
          }
        }
      }

      .honor-content {
        .honor-carousel-block {
          .honor-carousel-item {
            .honor-item{
              .honor-item-img {
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: fill;
                }

                span{
                  position: absolute;
                  bottom: 15px;
                  font-family: Source Han Sans CN;
                  font-size: 16px;
                  font-weight: 500;
                  line-height: normal;
                  text-align: center;
                  letter-spacing: 0.1em;

                  font-variation-settings: "opsz" auto;
                  color: #FFFFFF;

                  text-shadow: 0px 0px 10px #000000;
                }

              }
            }

          }
        }
      }

    }

    .honor-block {
      width: 128rem;
      .info-title-block {
        width: 128rem;
        .img-title {
          .info-title-img {
            width: 20px;
            height: 20px;
          }
          .info-title {
            font-size: 16px;
            margin-top: 4px;
          }
        }
        .info-title-more {
          font-size: 12px;
          margin-top: 6px;
          color: #55768c;
        }
      }
      .blue-line {
        width: 128rem;
      }
      .honor-content{
        width: 128rem;
      }

      .info-content {
        .info-content-item {
          width: 128rem;
          .dot-title {
            width: 100rem;
            .info-content-dot {
            }
            .info-content-title {
              font-size: 14px;
              width: 90rem;
            }
          }
          .info-content-time {
            font-size: 14px;
          }
        }
      }

      .honor-content {
        .honor-carousel-block {
          .honor-carousel-item {
            .honor-item{
              .honor-item-img {
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: fill;
                }

                span{
                  position: absolute;
                  bottom: 15px;
                  font-family: Source Han Sans CN;
                  font-size: 16px;
                  font-weight: 500;
                  line-height: normal;
                  text-align: center;
                  letter-spacing: 0.1em;

                  font-variation-settings: "opsz" auto;
                  color: #FFFFFF;

                  text-shadow: 0px 0px 10px #000000;
                }

              }
            }

          }
        }
      }


    }
  }

  .introduce-imgs-content {
    width: 128rem;
    .introduce-imgs-item {
      width: 128rem;
      height: 30rem;
    }
  }

  .college-news-content {
    min-width: 0;
    .college-news-carouse {
      width: 128rem;
      .college-news-carousel-img {
        width: 128rem;
        height: 101.4rem;
      }
      .college-news-carousel-title {
        height: 22px;
      }
    }
  }

  .college-new-content-block {
    width: 128rem;
    margin-top: 20px;
    min-width: 0;
    .college-new-content-block-list {
      width: 128rem;
      .college-news-content-img {
        height: 60rem;
      }
      &:nth-child(odd) {
        margin-right: 0px;
      }
    }
  }

  .common-block {
    width: 128rem;
    margin: 20px 8rem 0 8rem;
    .common-line {
      width: 128rem;
      .img-title {
        .common-line-logo {
          width: 20px;
          height: 20px;
        }
        .common-line-title {
          font-size: 16px;
          margin-top: 4px;
        }
      }

      .blue-line {
        width: 128rem;
      }
    }
    .common-link-content {
      .common-link-item {
        width: 128rem;
        /*height: 30rem;*/
      }
    }
  }
}
@media only screen and (max-width: 400px) {

  .my-swiper-box{
    .custom-carousel{
      :deep(.swiper-button-prev){
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        top: 50%;
        transform: translateY(-50%);
        opacity: 1;
        background: rgba(0,0,0,0.3);
        .el-icon-arrow-left{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

      :deep(.swiper-button-next){
        display: flex !important;
        width: 36px;
        height: 36px;
        top: 50%;
        border-radius: 18px;
        transform: translateY(-50%);
        background: rgba(0,0,0,0.3);
        opacity: 1;
        .el-icon-arrow-right{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

    }

  }


  .banner-block {
    .swiper-info-box {
      margin: 6px 0 0 38px;
      position: absolute;
      z-index: 60;
      .carousel_title {
        margin: 6px 0 0 38px;
        font-size: 14px;
      }
      .carousel_description {
        margin: 2px 0 0 38px;
        font-size: 12px;
        height: 20px;
      }
      .carousel_button {
        margin: 2px 0 0 38px;
        font-size: 12px;
        height: 20px !important;
        width: 120px;
        min-height: 22px;
      }
    }

  }
}



.my-swiper-box{
  width: 100%;
  min-width: 120rem; /* 设置div的宽度 */
  height: 100%; /* 设置div的高度 */
  position: relative;

  &:hover {

    :deep(.swiper-button-prev){
      display: flex !important;
      width: 36px;
      height: 36px;
      top: 50%;
      transform: translateY(-50%);
      opacity: 1;
      background: rgba(0,0,0,0.1);
      .el-icon-arrow-left{
        width: auto;
        height: auto;
        display: inline-block;
      }
    }

    :deep(.swiper-button-next){
      display: flex !important;
      width: 36px;
      height: 36px;
      top: 50%;
      border-radius: 18px;
      transform: translateY(-50%);
      background: rgba(0,0,0,0.1);
      opacity: 1;
      .el-icon-arrow-right{
        width: auto;
        height: auto;
        display: inline-block;
      }
    }

  }



  :deep(.swiper-button-prev){

    //display: none !important;
    transition: all 0.2s ease-in-out;
    width: 0px;
    height: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: normal;
    border-radius: 18px;
    background: rgba(0,0,0,0);
    opacity: 0;
    top: 50%;
    transform: translateY(-50%);

    &:after {
      font-size: 1.1rem;
      color: #fff;

    }

    .el-icon-arrow-left{
      width: 0;
      height: 0;
      display: none;
    }

  }

  :deep(.swiper-button-next){

    //display: none !important;
    transition: all 0.2s ease-in-out;
    width: 0px;
    height: 0px;
    display: flex;
    opacity: 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: normal;
    border-radius: 1.8rem;
    background: rgba(0,0,0,0);
    top: 50%;
    transform: translateY(-50%);
    &:after {
      font-size: 1.1rem;
      color: #fff;

    }

    .el-icon-arrow-right{
      width: 0;
      height: 0;
      display: none;
    }

  }


}

.my-swiper-box-bg{
  width: 100%;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--bgImage);
  background-size: 100% 100%;
  opacity: 1; /* 设置透明度 */
  z-index: -1; /* 确保伪元素在背 下 */
}


:deep(.swiper-pagination){
  bottom: 7px;
}
/* Swiper指示器的自定义样式 */
:deep(.swiper-pagination-bullet) {

  opacity: .48;
  width: 30px;
  height: 2px;
  background-color: #fff;
  border-radius: 10px;
  /* 其他样式按需修改 */
}

:deep(.swiper-pagination-bullet-active) {
  background-color: #fff;
  opacity: 1;
  /* 激活状态下的样式按需修改 */
}



</style>
